import { ObjectFieldTemplateProps } from '@rjsf/utils';

import { AttributeGrid } from 'design-system/components/Attribute';
import { Label } from 'design-system/components/Text';

export function ReadOnlyObjectFieldTemplate({
  properties,
  formData,
  schema,
}: ObjectFieldTemplateProps) {
  return (
    <AttributeGrid>
      {!schema.properties &&
      formData &&
      typeof formData === 'object' &&
      !Array.isArray(formData) ? (
        <AttributeGrid>
          {Object.entries(formData).map(([key, value]) => (
            <div key={key} style={{ marginBottom: '5px' }}>
              <Label size='md' weight='bold'>
                {key}:
              </Label>{' '}
              <span>{value || ''}</span>
            </div>
          ))}
        </AttributeGrid>
      ) : (
        properties.map((element) => <div key={element.content.key}>{element.content}</div>)
      )}
    </AttributeGrid>
  );
}
